import { Stack, type SxProps, type Theme } from "@mui/material";
import type { PropsWithChildren, ReactElement } from "react";
import { useBottomBarSpacing } from "web_myplann/Shared/Hooks/useBottomBarSpacing";
import { MobileLayoutContent } from "web_myplann/Shared/Layouts/MobileLayoutContent";
import { MobileLayoutTopBar } from "web_myplann/Shared/Layouts/MobileLayoutTopBar";

type Props = {
	topBar?: ReactElement;
	bottomBar?: ReactElement;
	disableContentPadding?: boolean;
	fullWidth?: boolean;
	disableBottomBar?: boolean;
	mainSx?: SxProps<Theme>;
	disableBottomPadding?: boolean;
	disableTopPadding?: boolean;
	bgColor?: string;
	topBarBgColor?: string;
	overlayTopBar?: boolean;
	disableBottomBarSpacing?: boolean;
};

export const MyPlannLayout = ({
	children,
	topBar,
	disableContentPadding,
	mainSx,
	disableBottomPadding,
	disableTopPadding,
	bgColor,
	topBarBgColor,
	overlayTopBar,
	disableBottomBarSpacing,
}: PropsWithChildren<Props>) => {
	const bottomBarSpacing = useBottomBarSpacing();
	const baseSx: SxProps<Theme> = {
		...(bgColor ? { background: bgColor } : {}),
		...(!disableBottomBarSpacing && bottomBarSpacing
			? { paddingBottom: bottomBarSpacing }
			: {}),
	};
	const contentSx: SxProps<Theme> = [
		baseSx,
		...(Array.isArray(mainSx) ? mainSx : mainSx ? [mainSx] : []),
	];

	return (
		<Stack
			sx={bgColor ? { background: bgColor, minHeight: "100vh" } : undefined}
		>
			<MobileLayoutTopBar
				topBar={topBar}
				disableTopPadding={disableTopPadding}
				topBarSx={{
					...((topBarBgColor ?? bgColor)
						? { backgroundColor: topBarBgColor ?? bgColor }
						: {}),
					...(overlayTopBar
						? { position: "absolute", top: 0, left: 0, right: 0 }
						: {}),
				}}
			/>

			<MobileLayoutContent
				disableContentPadding={disableContentPadding}
				disableBottomPadding={disableBottomPadding}
				mainSx={contentSx}
			>
				{children}
			</MobileLayoutContent>
		</Stack>
	);
};
